
import React, { useState } from 'react';
import { FiArrowLeft } from 'react-icons/fi';

const Wallet = () => {
  const questions = [
    {
      question: 'What is Moveonwheels?',
      answer: 'Moveonwheels is a self-drive bike rental service that provides you with all the privacy, fun, and convenience of your own bike, without the hassles of owning and maintaining one.'
    },
    {
      question: 'How do I book a bike here?',
      answer: 'You can book a bike in three ways; Download the Moveonwheels app or call 8762680082 or use our web application.'
    },
    {
      question: 'Where do I pick and drop the bike?',
      answer: 'Customers can pickup and drop to any of our franchises or Moveonwheels point mentioned in our website/app.'
    },
    {
      question: 'Is there any KM limit?',
      answer: 'Yes. All the bikes come along with KM limit. We have Small, Medium, Large packages which allows customer to unlock 5KM,10KM,15KM per hour respectively.'
    },
    {
      question: 'Do I need to pay anything extra in case of late return?',
      answer: 'Fine will be applicable. You can check on the app to extend the booking, else you can contact 8762680082 for the extension prior to the return date & time. However, the extension of booking is applicable only if the bike has no booking at that point.'
    },
    {
      question: 'What if I happen to meet with an accident?',
      answer: 'In case of accident or breakdown, you need to inform the company immediately. The customer shall pay only the difference amount of insurance claim amount. However, the customer has to pay the parking charges too. Also repair cost should be paid in advance.'
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen w-full flex flex-col items-center ">
      {/* Header Section */}
      <div className="w-full bg-[#FF7E00] text-white flex items-center py-3 px-4">
        <button className="text-white text-lg font-semibold flex items-center">
          <FiArrowLeft className="mr-2" />
        </button>
        <h1 className="text-xl font-bold flex-grow text-center">About Moveonwheels</h1>
      </div>

      {/* FAQ Section */}
      <div className="space-y-3 w-full mt-6 p-6">
        {questions.map((item, index) => (
          <div
            key={index}
            className="w-full bg-gray-100 rounded-md shadow-sm border-gray-200"
          >
            <div
              onClick={() => handleToggle(index)}
              className="py-4 px-6 text-gray-700 text-left cursor-pointer"
            >
              {item.question}
            </div>
            {activeIndex === index && (
              <div className="px-6 pb-4 pt-2 text-gray-600 border-t border-gray-200">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wallet;